import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material';

export default function Checkbox(props) {
    const { checkboxProps, name, ...rest } = props;

    return (
        <FormControlLabel
            {...rest}
            disabled={props.disabled}
            value={props.value}
            label={props.label}
            control={<MuiCheckbox {...checkboxProps} name={name} />}
            sx={{ mb: 0, ...props.sx }}
        />
    );
}
